// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4594af0","239":"c0e1f470","453":"a5a3c68a","455":"511e07c0"}[chunkId] + ".chunk.js";
};